/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown>, seconds: NonNullable<unknown> }} Progression_Duration_IncreaseInputs */

const en_us2_progression_duration_increase = /** @type {(inputs: Progression_Duration_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise}: hold ${i?.seconds} s longer next time`)
};

const pt_br2_progression_duration_increase = /** @type {(inputs: Progression_Duration_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise}: segure ${i?.seconds} s a mais na próxima`)
};

const es_419_progression_duration_increase = /** @type {(inputs: Progression_Duration_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise}: aguanta ${i?.seconds} s más la próxima vez`)
};

const pt_pt2_progression_duration_increase = /** @type {(inputs: Progression_Duration_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise}: aguenta mais ${i?.seconds} s na próxima`)
};

const fr_fr2_progression_duration_increase = /** @type {(inputs: Progression_Duration_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} : tiens ${i?.seconds} s de plus la prochaine fois`)
};

const de_de2_progression_duration_increase = /** @type {(inputs: Progression_Duration_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise}: nächstes Mal ${i?.seconds} s länger halten`)
};

const it_it2_progression_duration_increase = /** @type {(inputs: Progression_Duration_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise}: tieni ${i?.seconds} s in più la prossima volta`)
};

/**
* | output |
* | --- |
* | "{exercise}: hold {seconds} s longer next time" |
*
* @param {Progression_Duration_IncreaseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_duration_increase = /** @type {((inputs: Progression_Duration_IncreaseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Duration_IncreaseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_duration_increase(inputs)
	if (locale === "es-419") return es_419_progression_duration_increase(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_duration_increase(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_duration_increase(inputs)
	if (locale === "de-DE") return de_de2_progression_duration_increase(inputs)
	if (locale === "it-IT") return it_it2_progression_duration_increase(inputs)
	return en_us2_progression_duration_increase(inputs)
});
export { progression_duration_increase as "progression.duration_increase" }